module.exports = __webpack_public_path__ + "assets/img/web01.599d11f1.png";